import { BASE_URL } from "../../shared/utils/variables";
import { getAuthHeaders } from "../../shared/services/authentication";

const baseURL = BASE_URL;

export const fetchNotification = async () => {
    const options = {
        method: 'GET',
        headers: { 
            "Content-Type": "application/json",
            ...getAuthHeaders()
        }
    };
        
    try {
        const response: any = await fetch(`${baseURL}/notifications`, options);
        
        if (!response.ok) {
            let errorMessage = `Erro HTTP ${response.status}`;
            throw new Error(errorMessage);
        }
        const data = await response.json();
        
        return data;
        
    } catch (error) {
        throw new Error(`Erro ao buscar notificações: ${error}`);
    }
}

export const fetchUnreadCount = async () => {
    try {
        const response = await fetch(`${baseURL}/notifications/unread-count`, {
            method: 'GET',
            headers: { 
                "Content-Type": "application/json",
                ...getAuthHeaders()
            }
        });
        
        if (!response.ok) {
            let errorMessage = `Erro HTTP ${response.status}`;
            throw new Error(errorMessage);
        }
        const data = await response.json();
        
        return data;
        
    } catch (error) {
        throw new Error(`Erro ao buscar contador de notificações não lidas: ${error}`);
    }
};

export const fetchMarkAsRead = async (notificationId: string | number) => {
    try {
        const response = await fetch(`${baseURL}/notifications/${notificationId}/read`, {
            method: 'PATCH',
            headers: { 
                "Content-Type": "application/json",
                ...getAuthHeaders()
            }
        });
        
        if (!response.ok) {
            let errorMessage = `Erro HTTP ${response.status}`;
            throw new Error(errorMessage);
        }
        const data = await response.json();
        
        return data;
        
    } catch (error) {
        throw new Error(`Erro ao marcar notificação como lida: ${error}`);
    }
};

export const fetchMarkAllAsRead = async () => {
    try {
        const response = await fetch(`${baseURL}/notifications/mark-all-read`, {
            method: 'PATCH',
            headers: { 
                "Content-Type": "application/json",
                ...getAuthHeaders()
            }
        });
        
        if (!response.ok) {
            let errorMessage = `Erro HTTP ${response.status}`;
            throw new Error(errorMessage);
        }
        const data = await response.json();
        
        return data;
        
    } catch (error) {
        throw new Error(`Erro ao marcar todas as notificações como lidas: ${error}`);
    }
};

export const fetchUnreadNotificationsList = async () => {
    try {
        const response = await fetch(`${baseURL}/notifications/unread-list`, {
            method: 'GET',
            headers: { 
                "Content-Type": "application/json",
                ...getAuthHeaders()
            }
        });
        
        if (!response.ok) {
            let errorMessage = `Erro HTTP ${response.status}`;
            throw new Error(errorMessage);
        }
        const data = await response.json();
        
        return data;
        
    } catch (error) {
        throw new Error(`Erro ao marcar todas as notificações como lidas: ${error}`);
    }
};